export type HeadingType = "None" | "H1" | "H2" | "H3";

export const getHeadingElement = (
  headingType?: HeadingType
): React.ElementType | undefined => {
  if (headingType === "H1") return "h1";
  if (headingType === "H2") return "h2";
  if (headingType === "H3") return "h3";
  return undefined;
};
